module.exports = __webpack_public_path__ + "img/home-2-about-bg-effect.a842632d.png";